module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-05.970b5cf5.svg";